import React, { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom"; // Recommended over window.location
import LoginPage from "../Login/LoginPage";

const Login = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const providerName = localStorage.getItem("providerName");
    if (auth.isAuthenticated) {
      navigate("/home");
      return;
    }
    if (providerName === "RRD-SSO" || providerName === "WL-SSO") {
      auth.signinRedirect({
        extraQueryParams: {
          identity_provider: providerName,
        },
      });
    }
  }, [auth.isAuthenticated, auth.signinRedirect, navigate]);

  // Case 3: Show Login UI while loading or if no SSO provider is set
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }
  return <LoginPage />;
};
export default Login;